import { patch, put, get } from "../api";
import { User, UpdateProfileRequest } from "../../model/Model";

export async function changerRoleActif(role: string): Promise<User> {
    try {
        const response = await patch('/v1/utilisateurs/role', { role }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors du changement de rôle:', error);
        throw error;
    }
}

export async function getProfilUtilisateur(): Promise<User> { 
    try {
        const response = await get('/v1/utilisateurs/profil');
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors de la récupération du profil:', error);
        throw error;
    }
}

export async function updateProfilUtilisateur(data: UpdateProfileRequest): Promise<User> {
    try {
        const response = await put('/v1/utilisateurs/profil', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors de la mise à jour du profil:', error);
        throw error;
    }
}
